import React from 'react';
import styled from 'styled-components';
import { Forbes, Mashable, TC, TechCrunch } from './logos';

const PressLogos = styled.div`
  display: flex;
  flex-direction: revert;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 48px;
  
  svg {
    flex: 1 0 40%;
    
    &:nth-child(-n+2) {
      margin-bottom: 20px;
    }
    &:nth-child(odd) {
      margin-right: 20px;
    }
  }
`;

const PessLogos = () => (
  <PressLogos>
    {Forbes}
    {Mashable}
    {TC}
    {TechCrunch}
  </PressLogos>
);

export default PessLogos